import React from "react"
import { StaticQuery, graphql } from "gatsby"

const LocationQuery = ({ slug = '', render: Render }) => (
  <StaticQuery
    query={graphql`
      query {
        allContentfulLocation {
          edges {
            node {
              id
              title
              slug
              tagline
              neighborhood
              address {
                addressLine1
                addressLine2
                city
                state
                zipCode
              }
              membershipOptions {
                id
                title
              }
              people {
                firstName
                lastName
                role
                photo {
                  resize(width: 1000) {
                    src
                  }
                }
              }
              thumbnailImage {
                resize(width: 1000) {
                  src
                }
              }
              contentModules {
                __typename
                ...on ContentfulSectionImageWithContent {
                  id
                }
                ...on ContentfulSectionMap {
                  id
                }
                ...on ContentfulSectionTeam {
                  id
                }
                ...on ContentfulSectionGallery {
                  id
                }
              }
              locationPDF {
                file {
                  url
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const location = data.allContentfulLocation.edges.find(({ node }) => (
        node.slug === slug
      ))

      return <Render data={{ ...location.node, __typename: 'contentfulLocation' }} />
    }}
  />
)

export default LocationQuery
